export default __webpack_public_path__ + "static/pastry-1-bf092f5c8db84e210da9ed9b1145fd83.jpg";